import React, { useState, useEffect, Fragment } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import Select from "react-select";
import ReactLoading from "react-loading";
import {
  formatDateNoTime,
  getTodayDate,
  getTodayDateISO,
  getTodayDateNoTime,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common";
import Navbar from "../../../Components/Navbar/Navbar";
import InputError from "../../../Components/InputError/InputError";
import Employees from "../Employees.css";
//api
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { validatePayroll } from "./../../../Helpers/Validation/Employees/PayrollValidation";
import {
  getPayroll,
  createPayroll,
  updatePayroll,
  computePayroll,
} from "./../../../Helpers/apiCalls/Employees/PayrollApi";
import Moment from "moment";
import Footer from "../../../Components/Footer/Footer";

function MultipleFormPayroll({ add, edit }) {
  //variables
  const { id } = useParams();
  let navigate = useNavigate();
  const { state } = useLocation();
  // 
  const [inactive, setInactive] = useState(true);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [employees, setEmployees] = useState([]);
  const today = getTodayDateISO();
  const [cashAdvances, setCashAdvances] = useState([]);
  const [shortages, setShortages] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [computation, setComputation] = useState([]);
  const [employeeIds, setEmployeeIds] = useState(state?.ids);
  // 
  const [addDetails, setAddDetails] = useState({});
  const [isError, setIsError] = useState({
    employee_id: false,
    disbursement_date: false,
    date_from: false,
    date_to: false,
    rate: false,
    total_working_hours: false,
    basic_pay: false,
  });

  //functions
  const handleAddChange = (e, type) => {
    if (type === "select") {
      setAddDetails((prevState) => ({
        ...prevState,
        [e.for]: e.value,
        [e.select_value]: {
          for: e.for,
          label: e.label,
          value: e.value,
        },
      }));
    } else {
      setIsChanged(true);
      const { name, value, checked } = e.target;
      // 
      if (name === "show_other_allowances") {
        if (addDetails.show_other_allowances === "1") {
          setAddDetails((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddDetails((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "overtime") {
        if (value === "") {
          setAddDetails((prevState) => ({
            ...prevState,
            [name]: "",
            ["overtime_pay"]: 0,
          }));
        } else if (addDetails.thirty_percent) {
          var total = parseFloat(value) * parseFloat(addDetails.rate);
          var thirtyPercent = parseFloat((total * 0.3).toFixed(2));
          setAddDetails((prevState) => ({
            ...prevState,
            [name]: value,
            ["overtime_pay"]: total + thirtyPercent,
          }));
        } else {
          var total = parseFloat(value) * parseFloat(addDetails.rate);
          setAddDetails((prevState) => ({
            ...prevState,
            [name]: value,
            ["overtime_pay"]: total,
          }));
        }
      } else if (name === "thirty_percent") {
        if (checked) {
          var total =
            parseFloat(addDetails.overtime) * parseFloat(addDetails.rate);
          var thirtyPercent = parseFloat((total * 0.3).toFixed(2));
          setAddDetails((prevState) => ({
            ...prevState,
            [name]: checked,
            ["overtime_pay"]: total + thirtyPercent,
          }));
        } else {
          var total =
            parseFloat(addDetails.overtime) * parseFloat(addDetails.rate);
          setAddDetails((prevState) => ({
            ...prevState,
            [name]: checked,
            ["overtime_pay"]: total,
          }));
        }
      } else if (name === "total_working_hours") {
        var tempval = value !== "" ? value : 0;
        setAddDetails((prevState) => ({
          ...prevState,
          [name]: value,
          ["basic_pay"]: parseFloat(addDetails.rate) * parseFloat(tempval),
        }));
      } else {
        setAddDetails((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
      setTimeout(() => setIsChanged(false), 1);
    }
  };
  // 

  function handleShortageChange(e, row) {
    setIsChanged(true);
    var temp = [...shortages];
    const { name, value } = e.target;
    // 

    if (value === "") {
      toast.error("Please enter cash advance amount or put 0", {
        style: toastStyle(),
      });
      temp[row][name] = "";
      setShortages(temp);
      setTimeout(() => setIsChanged(false), 1);
      var shortageTotal = temp
        .map((data) => (data.amount !== "" ? parseFloat(data.amount) : 0))
        .reduce((a, b) => a + b, 0);
      setAddDetails((prevState) => ({
        ...prevState,
        ["total_shortage"]: shortageTotal,
      }));
    } else {
      if (parseFloat(temp[row]["total_balance"]) >= parseFloat(value)) {
        temp[row][name] = value;
        setShortages(temp);
        setTimeout(() => setIsChanged(false), 1);

        var shortageTotal = temp
          .map((data) => parseFloat(data.amount))
          .reduce((a, b) => a + b, 0);
        setAddDetails((prevState) => ({
          ...prevState,
          ["total_shortage"]: shortageTotal,
        }));
      } else {
        toast.error(
          "Cash advance amount should not exceed " + temp[row]["total_balance"],
          {
            style: toastStyle(),
          }
        );
        temp[row][name] = temp[row]["total_balance"];
        setShortages(temp);
        setTimeout(() => setIsChanged(false), 1);
      }
    }
  }
  // 

  function handleCashAdvanceChange(e, row) {
    setIsChanged(true);
    var temp = [...cashAdvances];
    const { name, value } = e.target;
    // 

    if (name === "amount") {
      if (value === "") {
        toast.error("Please enter cash advance amount or put 0", {
          style: toastStyle(),
        });
        temp[row][name] = "";
        setCashAdvances(temp);
        setTimeout(() => setIsChanged(false), 1);
      } else {
        if (parseFloat(temp[row]["balance"]) >= parseFloat(value)) {
          temp[row][name] = value;
          setCashAdvances(temp);
          setTimeout(() => setIsChanged(false), 1);
        } else {
          toast.error(
            "Cash advance amount should not exceed " + temp[row]["balance"],
            {
              style: toastStyle(),
            }
          );
          temp[row][name] = temp[row]["balance"];
          setCashAdvances(temp);
          setTimeout(() => setIsChanged(false), 1);
        }
      }
    } else {
      temp[row][name] = value;
      setCashAdvances(temp);
    }
  }
  // 
  

  const handleSubmit = () => {
    if (add) handleCreatePayroll();
    else if (edit) handleUpdatePayroll();
  };

  // const handleSave = () => {
  //     if (add) handleCreatePayroll("save");
  //     else if (edit) handleUpdatePayroll("save");
  // };

  //API
  async function fetchEmployees() {
    const response = await getAllEmployees();
    if (response.error) {
      setEmployees([]);
    } else {
      let result = response.data.data.map((data) => {
        var employee = data;
        employee.for = "employee_id";
        employee.select_value = "employee_id_value";
        employee.label = data.first_name + " " + data.last_name;
        employee.value = data.id;
        return employee;
      });
      setEmployees(result);
    }
  }
  // 

  async function handleCreatePayroll(type) {
    if (isSubmitClicked) {
      return;
    }
    if (validatePayroll(addDetails, setIsError)) {
      setIsSubmitClicked(true);
      const response = await createPayroll(addDetails, cashAdvances, shortages);
      // 
      if (response.data) {
        toast.success("Successfully created payroll!", {
          style: toastStyle(),
        });
        var array = employeeIds;
        array.splice(0, 1);
        // setEmployeeIds(array)
        fetchComputation(array);
        setIsSubmitClicked(false);
      } else {
        toast.error(response.error.response.data.messages.error, {
          style: toastStyle(),
        });
        setTimeout(() => {
          setIsSubmitClicked(false);
        }, 1000);
      }
    } else {
      toast.error("Please fill in all fields", {
        style: toastStyle(),
      });
    }
  }

  function handleSkip() {
    var array = employeeIds;
    array.splice(0, 1);
    // setEmployeeIds(array)
    fetchComputation(array);
  }

  async function handleUpdatePayroll(type) {
    if (isSubmitClicked) {
      return;
    }
    if (validatePayroll(addDetails, setIsError)) {
      const response = await updatePayroll(addDetails, cashAdvances, shortages);
      // 
      if (response.data) {
        if (response.data.status === "success") {
          toast.success("Successfully updated payroll!", {
            style: toastStyle(),
          });
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        } else {
          toast.error("Something went wrong", {
            style: toastStyle(),
          });
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        }
      }
    } else {
      toast.error("Please fill in all fields", {
        style: toastStyle(),
      });
    }
  }

  async function fetchComputation(ids) {
    setAddDetails({
      disbursement_date: state
        ? Moment(state.disbursement_date).format("YYYY-MM-DD")
        : today,
      rate: "",
      wastage: "",
      remarks: "",
      holiday_description: "",
      other_wages_description: "",
      other_deductions_description: "",
      disbursement_type: "atm",
      thirty_percent: false,
      philhealth: 0,
      sss: 0,
      sss_loan: 0,
      pagibig: 0,
      pagibig_loan: 0,
      shortage: 0,
      cash_advance: 0,
      other_allowance: 0,
      other_allowances: 0,
      transportation_allowance: 0,
      holidays: 0,
      other_deductions: 0,
      other_wages: 0,
      thirteenth_month: 0,
      bonus: 0,
      service_incentive: 0,
      basic_pay: 0,
      basic_w_overtime: 0,
      total_deduction: 0,
      total_additions: 0,
      grand_total: 0,
      rent: 0,
    });

    if (ids.length > 0) {
      setIsChanged(true);
      
      const response = await computePayroll({
        employee_id: ids[0],
        date_from: state.date_from,
        date_to: state.date_to,
      });
      // 

      if (response.error) {
        toast.error(response.error.response.data.messages.error, {
          style: toastStyle(),
        });
      } else {
        var details = response.data.map((data) => {
          var info = data;
          return info;
        });
        
        setComputation(details[0]);

        var shortage = details[0].deductions[0].shortages.map((data) => {
          var info = data;
          data.amount = data.total_balance;
          return info;
        });
        setShortages(shortage);

        var shortageTotal = shortage
          .map((data) => parseFloat(data.amount))
          .reduce((a, b) => a + b, 0);

        var cashadvance = details[0].deductions[0].cash_advances.map((data) => {
          var info = data;
          data.amount =
            parseInt(data.balance) < parseInt(data.payable_per_payroll)
              ? data.balance
              : data.payable_per_payroll;
          data.payable_per_payroll =
            parseInt(data.balance) < parseInt(data.payable_per_payroll)
              ? data.balance
              : data.payable_per_payroll;
          data.balance = data.balance;
          data.remarks = "";
          return info;
        });
        setCashAdvances(cashadvance);

        var holiday = details[0].additions.holidays;
        setHolidays(holiday);

        var holidayTotal = holiday
          .map((data) => parseFloat(data.amount))
          .reduce((a, b) => a + b, 0);

        setAddDetails((prevState) => ({
          ...prevState,
          ["employee_name"]: details[0].employee_name,
          ["employee_id"]: details[0].employee_id,
          ["date_from"]: details[0].date_from,
          ["date_to"]: details[0].date_to,
          ["rate"]: details[0].rate,
          ["type"]: details[0].type,
          ["has_hours"]: details[0].total_working_hours > 0 ? true : false,
          ["total_working_hours"]: details[0].total_working_hours,
          ["system_working_hours"]: details[0].total_working_hours,
          ["basic_pay"]:
            details[0].type === "monthly"
              ? details[0].basic_pay
              : details[0].total_working_hours !== 0
              ? details[0].basic_pay
              : 0,
          // ["basic_w_overtime"]: details[0].type === "monthly" ? details[0].basic_pay : details[0].total_working_hours !== 0 ? details[0].basic_pay : 0,
          ["philhealth"]: details[0].deductions[0].philhealth,
          ["sss"]: details[0].deductions[0].sss,
          ["pagibig"]: details[0].deductions[0].pagibig,
          ["sss_loan"]: details[0].deductions[0].sss_loan_balance,
          ["pagibig_loan"]: details[0].deductions[0].pagibig_loan_balance,
          ["transportation_allowance"]:
            details[0].additions.transportation_allowance,
          ["other_allowances"]: details[0].additions.other_allowances,
          ["total_shortage"]: shortageTotal,
          ["holidays"]: holidayTotal,

          ["absences"]: details[0].absences,
          ["overtime"]: details[0].overtime_hours,
          ["system_overtime_hours"]: details[0].overtime_hours,
          ["overtime_pay"]: details[0].overtime_pay
            ? details[0].overtime_pay
            : 0,
          ["thirty_percent"]: details[0].overtime_additional
            ? details[0].overtime_additional
            : false,
          ["undertime_hours"]: details[0].undertime_hours,
          ["basic_w_overtime"]: details[0].gross_pay ? details[0].gross_pay : 0,
          ["rent"]: details[0].deductions[0].rent,
        }));
      }
      setTimeout(() => setIsChanged(false), 1);
    } else {
      setTimeout(() => {
        navigate(-1);
      }, 1000);
    }
  }
  // 

  async function fetchData() {
    setAddDetails([]);

    const response = await getPayroll(id);
    // 

    if (response.error) {
      // TokenExpiry(response);
    } else {
      var data = response.data.data[0];
      data.total_additions = data.total_addition;
      data.employee_id_value = {
        label: data.employee_name,
        value: data.employee_id,
        for: "employee_id",
        select_value: "employee_id_value",
      };
      setAddDetails(data);
      // setEmployeeDetails(data[0].employees)
    }
  }

  useEffect(() => {
    // if(add) {
    //     // fetchEmployees();
    //     fetchComputation()
    // }
    if (edit) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    fetchComputation(state?.ids);
  }, []);

  useEffect(() => {
    var tempOtherFees = addDetails.other_fees
      ? parseFloat(addDetails.other_fees)
      : 0;

    var tempShortage = shortages
      .map((shortage) =>
        parseFloat(shortage.amount !== "" ? shortage.amount : 0)
      )
      .reduce((a, b) => a + b, 0);

    var tempCashAdvance = cashAdvances
      .map((ca) => parseFloat(ca.amount !== "" ? ca.amount : 0))
      .reduce((a, b) => a + b, 0);

    var tempTotalDeduction =
      parseFloat(addDetails.philhealth !== "" ? addDetails.philhealth : 0) +
      parseFloat(addDetails.sss !== "" ? addDetails.sss : 0) +
      parseFloat(addDetails.pagibig !== "" ? addDetails.pagibig : 0) +
      // parseFloat(addDetails.role !== "" ? addDetails.role : 0) +
      tempShortage +
      tempCashAdvance +
      parseFloat(
        addDetails.other_deductions !== "" ? addDetails.other_deductions : 0
      ) +
      parseFloat(addDetails.sss_loan !== "" ? addDetails.sss_loan : 0) +
      parseFloat(addDetails.pagibig_loan !== "" ? addDetails.pagibig_loan : 0) +
      parseFloat(addDetails.rent !== "" ? addDetails.rent : 0);

    var tempTotalAddition = 0;
    tempTotalAddition =
      parseFloat(
        addDetails.transportation_allowance !== ""
          ? addDetails.transportation_allowance
          : 0
      ) +
      parseFloat(
        addDetails.other_allowances !== "" ? addDetails.other_allowances : 0
      ) +
      parseFloat(addDetails.holidays !== "" ? addDetails.holidays : 0) +
      parseFloat(addDetails.other_wages !== "" ? addDetails.other_wages : 0) +
      parseFloat(
        addDetails.thirteenth_month !== "" ? addDetails.thirteenth_month : 0
      ) +
      parseFloat(addDetails.bonus !== "" ? addDetails.bonus : 0) +
      parseFloat(
        addDetails.service_incentive !== "" ? addDetails.service_incentive : 0
      );

    var tempTotalBasicWOverTime =
      parseFloat(addDetails.basic_pay !== "" ? addDetails.basic_pay : 0) +
      parseFloat(addDetails.overtime_pay !== "" ? addDetails.overtime_pay : 0);

    var _subtotal = addDetails.amount ? parseFloat(addDetails.amount) : 0;
    var _grandTotal =
      tempTotalBasicWOverTime + tempTotalAddition - tempTotalDeduction;

    setAddDetails((prev) => {
      return {
        ...prev,
        subtotal: _subtotal.toFixed(2),
        grand_total: _grandTotal.toFixed(2),
        basic_w_overtime: tempTotalBasicWOverTime.toFixed(2),
        total_deduction: tempTotalDeduction.toFixed(2),
        total_additions: tempTotalAddition.toFixed(2),
      };
    });
  }, [isChanged]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"PAYROLL"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* header */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> {add ? "ADD " : "EDIT "} PAYROLL </h1>
          </Col>
        </Row>

        {/* content */}
        <div className="edit-form">
          {/* FRANCHISEE SALES INVOICE DETAILS */}
          <Fragment>
            <Row className="pt-3 mb-2">
              <Col xs={4}>
                <span className="edit-label">
                  EMPLOYEE NAME
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={4}>
                <span className="edit-label">
                  DATE FROM
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={4}>
                <span className="edit-label">
                  DATE TO
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
            </Row>
            <Row>
              <Col xs={4}>
                <Form.Control
                  type="text"
                  name="employee_name"
                  className="nc-modal-custom-text"
                  value={addDetails.employee_name}
                  // onChange={(e) => handleAddChange(e)}
                  disabled
                />
                {/* <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select Employee..."
                                    value={addDetails.employee_id_value}
                                    options={employees}
                                    // onChange={(e) => handleAddChange(e, "select")}
                                    disabled
                                /> */}
                <InputError
                  isValid={isError.employee_id}
                  message={"Employee is required"}
                />
              </Col>
              <Col xs={4}>
                <Form.Control
                  type="date"
                  name="date_from"
                  className="nc-modal-custom-text"
                  value={addDetails.date_from}
                  // onChange={(e) => handleAddChange(e)}
                  disabled
                />
                <InputError
                  isValid={isError.date_from}
                  message={"Month is required"}
                />
              </Col>
              <Col xs={4}>
                <Form.Control
                  type="date"
                  name="date_to"
                  className="nc-modal-custom-text"
                  value={addDetails.date_to}
                  // onChange={(e) => handleAddChange(e)}
                  disabled
                />
                <InputError
                  isValid={isError.date_to}
                  message={"Month is required"}
                />
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col>
                <span className="edit-label">
                  DISBURSEMENT DATE
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              {/* <Col>
                                <span className="edit-label">
                                    Department
                                    <label className="badge-required">{` *`}</label>
                                </span>
                            </Col> */}
              <Col>
                <span className="edit-label">disbursement Type</span>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Control
                  type="date"
                  name="disbursement_date"
                  className="nc-modal-custom-text"
                  value={addDetails.disbursement_date}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.disbursement_date}
                  message={"Date is required"}
                />
              </Col>
              {/* <Col>
                                <Form.Control
                                    type="text"
                                    name="department"
                                    className="nc-modal-custom-text"
                                    value={addDetails.department}
                                    onChange={(e) => handleAddChange(e)} 
                                />
                                <InputError
                                    isValid={isError.department}
                                    message={"department is required"}
                                />
                            </Col> */}
              <Col>
                <Form.Select
                  type="select"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Type..."
                  name="disbursement_type"
                  value={addDetails.disbursement_type}
                  onChange={(e) => handleAddChange(e)}
                >
                  <option disabled selected value="">
                    Select
                  </option>
                  <option value="atm" selected>
                    ATM
                  </option>
                  <option value="palawan">Palawan</option>
                  <option value="cash">Cash</option>
                  <option value="others">Others</option>
                </Form.Select>
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col xs={3}>
                <span className="edit-label">
                  Rate
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="text"
                  name="rate"
                  className="nc-modal-custom-text text-end"
                  value={numberFormat(addDetails.rate)}
                  // onChange={(e) => handleAddChange(e)}
                  disabled
                />
              </Col>
              {addDetails.type === "hourly" && (
                <>
                  <Col xs={3}>
                    <span className="edit-label">
                      Total Working Hours
                      <label className="badge-required">{` *`}</label>
                    </span>
                  </Col>
                  <Col xs={3}>
                    <Form.Control
                      type="text"
                      name="total_working_hours"
                      className="nc-modal-custom-text text-end"
                      value={addDetails.total_working_hours}
                      onChange={(e) => handleAddChange(e)}
                      disabled={addDetails.has_hours ? true : false}
                    />
                  </Col>
                </>
              )}
            </Row>
            <Row className="mt-4 mb-2">
              <Col xs={3}>
                <span className="edit-label">
                  Basic Pay
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="text"
                  name="basic_pay"
                  className="nc-modal-custom-text text-end"
                  value={numberFormat(addDetails.basic_pay)}
                  // onChange={(e) => handleAddChange(e)}
                  disabled
                />
              </Col>
              <Col xs={3}>
                <span className="edit-label">
                  Undertime: {addDetails.undertime_hours}
                </span>
              </Col>
              <Col xs={3}>
                <span className="edit-label">
                  Absent: {addDetails.absences}
                </span>
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col xs={3}>
                <span className="edit-label">
                  OT Pay
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={2}>
                <Form.Control
                  type="text"
                  name="overtime_pay"
                  className="nc-modal-custom-text text-end"
                  value={numberFormat(addDetails.overtime_pay)}
                  // onChange={(e) => handleAddChange(e)}
                  disabled
                />
              </Col>
              <Col xs={1}>
                <Form.Group className="" controlId="formBasicCheckbox">
                  <Form.Check
                    type="checkbox"
                    label="30%"
                    name="thirty_percent"
                    // value="1"
                    className="pt-2"
                    onChange={(e) => handleAddChange(e)}
                  />
                </Form.Group>
              </Col>
              <Col xs={3}>
                <span className="edit-label">Overtime</span>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="text"
                  name="overtime"
                  className="nc-modal-custom-text text-end"
                  value={addDetails.overtime}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col xs={3}>
                <span className="edit-label">
                  Gross Pay
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="text"
                  name="basic_w_overtime"
                  className="nc-modal-custom-text text-end"
                  value={numberFormat(addDetails.basic_w_overtime)}
                  // onChange={(e) => handleAddChange(e)}
                  disabled
                />
              </Col>
            </Row>

            <Row className="mt-5 mb-2">
              <Col>
                <span className="edit-label">WAGES</span>
              </Col>
              <hr />
            </Row>
            <Row className="border-gray">
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">ALLOWANCES</span>
                </Col>
                <hr />
              </Row>
              <Row className="mt-1 mb-2">
                <Col xs={3}>
                  <span className="edit-label">Transportation Allowance</span>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    type="text"
                    name="transportation_allowance"
                    className="nc-modal-custom-text text-end"
                    value={addDetails.transportation_allowance}
                    // onChange={(e) => handleAddChange(e)}
                    disabled
                  />
                  <InputError
                    isValid={isError.transportation_allowance}
                    message={"transportation_allowance is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col xs={3}>
                  <span className="edit-label">OTHER ALLOWANCES</span>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    type="text"
                    name="other_allowances"
                    className="nc-modal-custom-text text-end"
                    value={addDetails.other_allowances}
                    // onChange={(e) => handleAddChange(e)}
                    disabled
                  />
                  <InputError
                    isValid={isError.other_allowances}
                    message={"other_allowances is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col xs={3}>
                  <span className="edit-label">Other Wages</span>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    type="text"
                    name="other_wages"
                    className="nc-modal-custom-text text-end"
                    value={addDetails.other_wages}
                    onChange={(e) => handleAddChange(e)}
                  />
                </Col>
                <Col xs={3}>
                  <span className="edit-label">DESCRIPTION</span>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    type="text"
                    name="other_wages_description"
                    className="nc-modal-custom-text"
                    value={addDetails.other_wages_description}
                    onChange={(e) => handleAddChange(e)}
                  />
                </Col>
              </Row>
              {holidays.length > 0 && (
                <>
                  <Row className="mt-2"></Row>
                  <hr />
                  <Row className="mt-2">
                    <Col xs={3}>
                      <span className="print-data">HOLIDAY</span>
                    </Col>
                    <Col xs={3}>
                      <span className="print-data">AMOUNT</span>
                    </Col>

                    <Col xs={3}>
                      <span className="print-data">DATE</span>
                    </Col>
                  </Row>
                </>
              )}
              {holidays.length > 0 ? (
                holidays?.map((data, index) => {
                  return (
                    <Row className="mt-2 mb-2">
                      <Col xs={3}>
                        <span className="edit-label">{data.description}</span>
                      </Col>
                      <Col xs={3}>
                        <Form.Control
                          type="text"
                          name="amount"
                          className="nc-modal-custom-text text-end"
                          value={numberFormat(data.amount)}
                          onChange={(e) => handleShortageChange(e, index)}
                          disabled
                        />
                      </Col>
                      <Col xs={3}>
                        <span className="edit-label">
                          {Moment(data.date).format("MMM DD, YYYY")}
                        </span>
                      </Col>
                    </Row>
                  );
                })
              ) : (
                <Row className="mt-4 mb-2 justify-contents-center">
                  <Col xs={3}>
                    <span className="edit-label">HOLIDAY</span>
                  </Col>
                  <Col xs={3}>
                    <span className="edit-label">No Holiday Found!</span>
                  </Col>
                </Row>
              )}

              <Row className="mt-4 mb-2">
                <Col xs={4}>
                  <Form.Group className="mt-3" controlId="formBasicCheckbox">
                    <Form.Check
                      type="checkbox"
                      label="Show other allowances"
                      name="show_other_allowances"
                      value="1"
                      className="pt-2"
                      onChange={(e) => handleAddChange(e)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {addDetails.show_other_allowances === "1" && (
                <>
                  <Row className="mt-4 mb-2">
                    <Col xs={3}>
                      <span className="edit-label">13th Month</span>
                    </Col>
                    <Col xs={3}>
                      <Form.Control
                        type="text"
                        name="thirteenth_month"
                        className="nc-modal-custom-text text-end"
                        value={addDetails.thirteenth_month}
                        onChange={(e) => handleAddChange(e)}
                      />
                      <InputError
                        isValid={isError.thirteenth_month}
                        message={"thirteenth_month is required"}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-4 mb-2">
                    <Col xs={3}>
                      <span className="edit-label">BONUS</span>
                    </Col>
                    <Col xs={3}>
                      <Form.Control
                        type="text"
                        name="bonus"
                        className="nc-modal-custom-text text-end"
                        value={addDetails.bonus}
                        onChange={(e) => handleAddChange(e)}
                      />
                      <InputError
                        isValid={isError.bonus}
                        message={"bonus is required"}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-4 mb-2">
                    <Col xs={3}>
                      <span className="edit-label">Service Incentive</span>
                    </Col>
                    <Col xs={3}>
                      <Form.Control
                        type="text"
                        name="service_incentive"
                        className="nc-modal-custom-text text-end"
                        value={addDetails.service_incentive}
                        onChange={(e) => handleAddChange(e)}
                      />
                      <InputError
                        isValid={isError.service_incentive}
                        message={"service_incentive is required"}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Row>
            <Row className="align-left py-1">
              <Col xs={2} className="text-start">
                <span className="edit-label color-gray">Total Wages</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle">
                  {numberFormat(addDetails.total_additions)}
                </span>
              </Col>
            </Row>

            <Row className="mt-5 mb-2">
              <Col>
                <span className="edit-label">DEDUCTIONS</span>
              </Col>
              <hr />
            </Row>
            <Row className="border-gray">
              <Row className="mt-4 mb-2">
                <Col>
                  <span className="edit-label">CONTRIBUTIONS</span>
                </Col>
                <hr />
              </Row>
              <Row className="mt-1 mb-2">
                <Col xs={3}>
                  <span className="edit-label">PhilHealth</span>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    type="text"
                    name="philhealth"
                    className="nc-modal-custom-text text-end"
                    value={addDetails.philhealth}
                    // onChange={(e) => handleAddChange(e)}
                    disabled
                  />
                  <InputError
                    isValid={isError.philhealth}
                    message={"philhealth is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col xs={3}>
                  <span className="edit-label">SSS</span>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    type="text"
                    name="sss"
                    className="nc-modal-custom-text text-end"
                    value={addDetails.sss}
                    // onChange={(e) => handleAddChange(e)}
                    disabled
                  />
                  <InputError
                    isValid={isError.sss}
                    message={"sss is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col xs={3}>
                  <span className="edit-label">pagibig</span>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    type="text"
                    name="pagibig"
                    className="nc-modal-custom-text text-end"
                    value={addDetails.pagibig}
                    // onChange={(e) => handleAddChange(e)}
                    disabled
                  />
                  <InputError
                    isValid={isError.pagibig}
                    message={"pagibig is required"}
                  />
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col xs={3}>
                  <span className="edit-label">rent</span>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    type="text"
                    name="rent"
                    className="nc-modal-custom-text text-end"
                    value={addDetails.rent}
                    // onChange={(e) => handleAddChange(e)}
                    disabled
                  />
                </Col>
              </Row>
              {shortages.length > 0 && (
                <>
                  <Row className="mt-2"></Row>
                  <hr />
                  <Row className="mt-2">
                    <Col xs={3}>
                      <span className="print-data">TOTAL SHORTAGE</span>
                    </Col>
                    <Col xs={3}>
                      <Form.Control
                        type="text"
                        name="amount"
                        className="nc-modal-custom-text text-end"
                        value={numberFormat(addDetails.total_shortage)}
                        disabled
                      />
                    </Col>

                    <Col xs={2}>
                      <span className="print-data">SOURCE</span>
                    </Col>
                    <Col xs={2}>
                      <span className="print-data">DATE</span>
                    </Col>
                    <Col xs={2}>
                      <span className="print-data">REMARKS</span>
                    </Col>
                  </Row>
                </>
              )}
              {shortages.length > 0 ? (
                shortages?.map((data, index) => {
                  return (
                    <Row className="mt-2 mb-2">
                      <Col xs={3}>
                        {/* <span className="edit-label">
                                                        Shortage
                                                    </span> */}
                      </Col>
                      <Col xs={3}>
                        <Form.Control
                          type="text"
                          name="amount"
                          className="nc-modal-custom-text text-end"
                          value={data.amount}
                          onChange={(e) => handleShortageChange(e, index)}
                          disabled
                        />
                      </Col>

                      <Col xs={2}>
                        <span className="edit-label">
                          {data.source === "cash_variance"
                            ? "Cash Variance"
                            : "inventory variance"}
                        </span>
                      </Col>
                      <Col xs={2}>
                        <span className="edit-label">
                          {Moment(data.date).format("MMM DD, YYYY")}
                        </span>
                      </Col>
                      <Col xs={2} className="break-word">
                        <span className="edit-label">
                          {data.remarks}
                        </span>
                      </Col>
                    </Row>
                  );
                })
              ) : (
                <Row className="mt-4 mb-2 justify-contents-center">
                  <Col xs={3}>
                    <span className="edit-label">Shortage</span>
                  </Col>
                  <Col xs={3}>
                    <span className="edit-label">No Shortage Found!</span>
                  </Col>
                </Row>
              )}
              {cashAdvances.length > 0 && (
                <>
                  <Row className="mt-2"></Row>
                  <hr />
                  <Row className="mt-2">
                    <Col xs={2}>
                      <span className="print-data">TYPE</span>
                    </Col>
                    <Col xs={2}>
                      <span className="print-data">DATE</span>
                    </Col>
                    <Col xs={2}>
                      <span className="print-data">AMOUNT</span>
                    </Col>
                    <Col xs={2}>
                      <span className="print-data right">BALANCE</span>
                    </Col>
                    <Col xs={2}>
                      <span className="print-data">FULL PMYT DATE</span>
                    </Col>
                    <Col xs={2}>
                      <span className="print-data">NO. OF TIMES PAID</span>
                    </Col>
                  </Row>
                </>
              )}
              {cashAdvances.length > 0 ? (
                cashAdvances?.map((data, index) => {
                  return (
                    <Row className="mt-2 mb-2">
                      <Col xs={2}>
                        <span className="edit-label">
                          {data.type.split("_")[0] +
                            " " +
                            data.type.split("_")[1]}
                        </span>
                      </Col>
                      <Col xs={2}>
                        <span className="edit-label">{data.date}</span>
                      </Col>
                      <Col xs={2}>
                        <Form.Control
                          type="text"
                          name="amount"
                          className="nc-modal-custom-text text-end"
                          value={data.amount}
                          onChange={(e) => handleCashAdvanceChange(e, index)}
                        />
                      </Col>
                      <Col xs={2}>
                        <span className="edit-label right">
                          {numberFormat(data.balance)}
                        </span>
                      </Col>
                      <Col xs={2}>
                        <span className="edit-label">
                          {data.full_payment_date
                            ? Moment(data.full_payment_date).format(
                                "MMM DD, YYYY"
                              )
                            : ""}
                        </span>
                      </Col>
                      <Col xs={2}>
                        <span className="edit-label">
                          {data.no_of_times_paid}
                        </span>
                      </Col>
                    </Row>
                  );
                })
              ) : (
                <Row className="mt-4 mb-2 justify-contents-center">
                  <Col xs={3}>
                    <span className="edit-label">Cash Advance/Loan</span>
                  </Col>
                  <Col xs={3}>
                    <span className="edit-label">
                      No Cash Advance/Loan Found!
                    </span>
                  </Col>
                </Row>
              )}
              <Row className="mt-4 mb-2">
                <Col xs={3}>
                  <span className="edit-label">Other Deductions</span>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    type="text"
                    name="other_deductions"
                    className="nc-modal-custom-text text-end"
                    value={addDetails.other_deductions}
                    onChange={(e) => handleAddChange(e)}
                  />
                </Col>
                <Col xs={3}>
                  <span className="edit-label">DESCRIPTION</span>
                </Col>
                <Col xs={3}>
                  <Form.Control
                    type="text"
                    name="other_deductions_description"
                    className="nc-modal-custom-text"
                    value={addDetails.other_deductions_description}
                    onChange={(e) => handleAddChange(e)}
                  />
                </Col>
              </Row>
            </Row>
            {/* COMMENTED SA */}
            {/* <Row className="border-gray mt-4">
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        LOANS
                                    </span>
                                </Col>
                                <hr/>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col xs={3}>
                                    <span className="edit-label">
                                        SSS LOAN
                                    </span>
                                </Col>
                                <Col xs={3}>
                                    <Form.Control
                                        type="text"
                                        name="sss_loan"
                                        className="nc-modal-custom-text text-end"
                                        value={addDetails.sss_loan}
                                        onChange={(e) => handleAddChange(e)} 
                                    />
                                    <InputError
                                        isValid={isError.sss_loan}
                                        message={"sss_loan is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col xs={3}>
                                    <span className="edit-label">
                                        pagibig loan
                                    </span>
                                </Col>
                                <Col xs={3}>
                                    <Form.Control
                                        type="text"
                                        name="pagibig_loan"
                                        className="nc-modal-custom-text text-end"
                                        value={addDetails.pagibig_loan}
                                        onChange={(e) => handleAddChange(e)} 
                                    />
                                    <InputError
                                        isValid={isError.pagibig_loan}
                                        message={"pagibig_loan is required"}
                                    />
                                </Col>
                            </Row>
                        </Row> */}
            <Row className="align-left py-1">
              <Col xs={2} className="text-start">
                <span className="edit-label color-gray">Total Deduction</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label-red align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label-red align-middle">
                  {numberFormat(addDetails.total_deduction)}
                </span>
              </Col>
            </Row>

            <Row className="mt-4 mb-2">
              <Col>
                <span className="edit-label">Remarks</span>
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col>
                <Form.Control
                  type="text"
                  name="remarks"
                  className="nc-modal-custom-text"
                  value={addDetails.remarks}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
          </Fragment>

          <Row className="align-right py-1 mt-3">
            <Col xs={2} className="text-end">
              <span className="edit-label color-gray">Gross Pay</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {addDetails.basic_w_overtime
                  ? numberFormat(addDetails.basic_w_overtime)
                  : "0.00"}
              </span>
            </Col>
          </Row>
          <Row className="align-right py-1">
            <Col xs={2} className="text-end">
              <span className="edit-label color-gray">Total Wages</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                +
                {addDetails.total_additions
                  ? numberFormat(addDetails.total_additions)
                  : "0.00"}
              </span>
            </Col>
          </Row>
          <Row className="align-right py-1">
            <Col xs={2} className="text-end">
              <span className="edit-label color-gray">Total Deduction</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label-red align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label-red align-middle">
                -
                {addDetails.total_deduction
                  ? numberFormat(addDetails.total_deduction)
                  : "0.00"}
              </span>
            </Col>
          </Row>
          <Row className="align-right py-3">
            <Col xs={2} className="text-end">
              <span className="edit-label color-gray grand-total-text">
                Net Pay
              </span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle grand-total-text">
                PHP
              </span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle grand-total-text">
                {addDetails.grand_total
                  ? numberFormat(addDetails.grand_total)
                  : "0.00"}
              </span>
            </Col>
          </Row>

          {/* FOOTER: CANCEL & SUBMIT BUTTONS */}
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              style={{ background: "#ffc107", color: "white" }}
              onClick={handleSkip}
            >
              Skip
            </button>
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            {/* {isSaveClicked ? (
                            <div className="button-secondary d-flex justify-content-center">
                                <ReactLoading
                                    type="bubbles"
                                    color="#FFFFFF"
                                    height={50}
                                    width={50}
                                />
                            </div>
                        ) : (
                            <button
                                type="button"
                                className="button-primary me-3"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        )} */}
            {isSubmitClicked ? (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={handleSubmit}
              >
                Generate
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default MultipleFormPayroll;
